// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SpzQ25EC5OOkga {
  display: inline;
  color: var(--ds-link, #0c66e4);
  cursor: pointer;
}
.SpzQ25EC5OOkga:hover {
  text-decoration: underline;
}
.vgyPS5yT2cy6H2 {
  color: var(--ds-text, #172b4d);
  cursor: default;
}
.vgyPS5yT2cy6H2:hover {
  text-decoration: none;
}
`, ""]);
// Exports
export var attachmentLink = `SpzQ25EC5OOkga`;
export var maliciousAttachment = `vgyPS5yT2cy6H2`;
export default ___CSS_LOADER_EXPORT___;
